import { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Upload, Grid, List } from "lucide-react";
import DocumentGrid from "./DocumentGrid";
import DocumentTable from "./DocumentTable";
import DocumentUploadModal from "./DocumentUploadModal";

interface DocumentSideModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DocumentSideModal = ({ open, onOpenChange }: DocumentSideModalProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState<"grid" | "list">("list");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-xl lg:max-w-2xl">
        <SheetHeader className="space-y-4">
          <SheetTitle>Document Management</SheetTitle>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search documents..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-8"
              />
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="icon"
                onClick={() => setViewMode(viewMode === "grid" ? "list" : "grid")}
              >
                {viewMode === "grid" ? (
                  <List className="h-4 w-4" />
                ) : (
                  <Grid className="h-4 w-4" />
                )}
              </Button>
              <Button onClick={() => setIsUploadModalOpen(true)}>
                <Upload className="h-4 w-4 mr-2" />
                Upload
              </Button>
            </div>
          </div>
        </SheetHeader>

        <div className="mt-8 pr-6">
          {viewMode === "grid" ? (
            <DocumentGrid searchQuery={searchQuery} />
          ) : (
            <DocumentTable searchQuery={searchQuery} />
          )}
        </div>

        <DocumentUploadModal
          open={isUploadModalOpen}
          onOpenChange={setIsUploadModalOpen}
          onUploadProgress={setUploadProgress}
        />
      </SheetContent>
    </Sheet>
  );
};

export default DocumentSideModal;